import { SET_ORDER_DATA } from "../actions/action";

const initialState = {
  orderData: [],
};

 const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDER_DATA:
      return {
        ...state,
        orderData: action.payload.orderData,
      };
    default:
      return state;
  }
};

export default orderReducer;
